import { makeAutoObservable } from 'mobx';

export default class TagsEditorStore {

    tags: string[];
    inputVisible: boolean;
    inputValue: string;
    editInputIndex: number;
    editInputValue: string;

    constructor() {
        this.tags = [];    
        this.inputVisible = false;    
        this.inputValue = '';
        this.editInputIndex = -1;
        this.editInputValue = '';
        makeAutoObservable(this);
    }

    reset(): void {
        this.tags = [];    
        this.inputVisible = false;    
        this.inputValue = '';
        this.editInputIndex = -1;
        this.editInputValue = '';
    }

    setTags(newTags: string[]): void {
        this.tags = newTags;
    }

    setInputVisible(value: boolean): void {
        this.inputVisible = value;
    }
    
    setInputValue(value: string): void {
        this.inputValue = value;
    }
    
    setEditInputValue(value: string): void {
        this.editInputValue = value;
    }

    setEditInputIndex(index: number): void {
        this.editInputIndex = index;
    }
    
    editTags(): void {
        
        this.tags[this.editInputIndex] = this.editInputValue;
        this.editInputIndex = -1;
        this.editInputValue = '';
    }

    setEditMode(index: number, tag: string): void {
        this.editInputIndex = index;
        this.editInputValue = tag;
    }

    get getTags(): string[] {
        return Object.assign([], this.tags);
    }

    get tagsAsString(): string {
        if (this.tags.length === 0) return ''; 
        return this.tags.reduce((acc, item) => acc + ', ' + item);
    }
}